module.exports = __webpack_public_path__ + "img/lava.08f68a7a.jpg";